import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaxCodeComponent } from './tax-code.component';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [TaxCodeComponent],
  exports:[TaxCodeComponent],
  imports: [
    CommonModule,
    FormsModule
  ]
})
export class TaxCodeModule { }
